import { useTranslation } from 'react-i18next'

import { SkeletonBlock } from './skeleton'

export function AppShellSkeleton() {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      aria-label={t('common.loading')}
      aria-busy="true"
      className="flex h-screen w-full flex-col bg-white"
    >
      <span className="sr-only">{t('common.loading')}</span>
      <header
        aria-hidden="true"
        className="flex min-h-14 items-center gap-5 border-b border-brand-dark bg-brand px-4 text-white sm:px-6"
      >
        <span className="text-lg font-bold tracking-wide">{t('nav.appNameShort')}</span>
        <div className="hidden items-center gap-3 lg:flex">
          <SkeletonBlock className="h-9 w-20 bg-white/30" />
          <SkeletonBlock className="h-9 w-24 bg-white/30" />
          <SkeletonBlock className="h-9 w-20 bg-white/30" />
          <SkeletonBlock className="h-9 w-28 bg-white/30" />
        </div>
        <SkeletonBlock className="ml-auto size-10 bg-white/30 lg:hidden" />
        <SkeletonBlock className="ml-auto hidden h-9 w-72 bg-white/30 lg:block" />
        <SkeletonBlock className="hidden h-9 w-20 bg-white/30 lg:block" />
      </header>

      <main className="min-h-0 flex-1 overflow-hidden">
        <h1 className="sr-only">{t('nav.appNameShort')}</h1>
        <div aria-hidden="true">
          <div className="flex flex-wrap items-center gap-3 border-b border-gray-200 bg-gray-50 p-4">
            <SkeletonBlock className="h-10 w-40" />
            <SkeletonBlock className="h-10 min-w-48 flex-1" />
            <SkeletonBlock className="h-10 w-24" />
          </div>
          <div className="space-y-4 p-4 sm:p-6">
            <SkeletonBlock className="h-6 w-56 max-w-full" />
            <div className="grid gap-3 sm:grid-cols-3">
              <SkeletonBlock className="h-20 w-full" />
              <SkeletonBlock className="h-20 w-full" />
              <SkeletonBlock className="h-20 w-full" />
            </div>
            <SkeletonBlock className="h-80 w-full" />
          </div>
        </div>
      </main>
    </div>
  )
}
